<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <page>
    <template v-slot:content>
      <div class="full-page">
        <transition name="slidedown">
          <div v-if="crumbsVisible" class="page-crumbs">
            <nav class="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <router-link
                  :key="`crumb_${crumb.name}`"
                  v-for="crumb in $route.meta.crumbs"
                  :to="{ name: crumb.name }"
                  tag="li"
                >
                  <a
                    ><span class="link">{{ crumb.label }}</span></a
                  >
                </router-link>
                <li class="is-active">
                  <a href="#" aria-current="page">Garden map</a>
                </li>
              </ul>
            </nav>
          </div>
        </transition>
        <section>
          <iframe class="map-iframe" :src="frameUrl"></iframe>
        </section>
      </div>
    </template>
  </page>
</template>

<script>
import Page from "./../common/page";
import { format } from "timeago.js";

export default {
  data() {
    return {
      crumbsVisible: false
    };
  },
  methods: {
    timeAgo(date) {
      return format(date);
    }
  },
  components: {
    Page
  },
  computed: {
    frameUrl() {
      const baseUrl = "https://registr.bz-uk.roamingowl.com/map";
      if (this.$route.query.plant) {
        return `${baseUrl}?plant=${this.$route.query.plant}`;
      }
      return baseUrl;
    }
  },
  metaInfo: {
    title: "Garden map"
  }
};
</script>
<style lang="scss" scoped>
@import "./../../styles/index";
@import "./page-scoped";

.full-page {
  width: 100%;
}

.map-iframe {
  width: 100%;
  height: calc(100vh - 105px);
}

.link {
  color: $color-text;
  cursor: pointer;

  &:hover {
    @include link-underline(#e1e1e1, $color-text, $color-selection);
  }
}

.bottom-links {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
</style>
